export default __webpack_public_path__ + "static/media/underline.e6895ecf.png";